module.exports = __webpack_public_path__ + "img/UnityFrameworkPathTool.367c0509.gif";